import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AppScaleProvider } from "../contexts/AppScaleContext";
import { mediaQueryPoint, useMediaQuery } from "../utils/hooks";
import {
  getCurrentUser,
  getTurnRemain,
  increaseCoachMark,
  loginWithPassword,
} from "../Redux/futures/account/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  curStateAccount,
  curStateMiniGame,
  curIsMaster,
} from "../Redux/selector";
import { useLocation, useNavigate } from "react-router";
import "moment/locale/en-gb";
import { getData, setData } from "../utils/localstorage";
import Cookies from "universal-cookie";
import {
  getItemCookie,
  setCookieChangePw,
  setCookieEvent,
} from "../utils/cookie";
import {
  APP_SCALE_BOOST,
  DESIGN_CANVAS,
  IS_UPDATE_VERSION_3_PROJECT,
  IS_UPDATE_VERSION_3_PROJECT_LOGIN,
  TYPE_USER,
} from "../helper/const";
import { getConfigMiniGame } from "../Redux/futures/mini-game/action";
import OrientationLock from "../component/OrientationLock";
import ModalRender from "../component/ModalRender";
import NewUserTourInvite from "../component/NewUserTourInvite";
import PATH from "../config/PATH";
import { clearNeverShowTourInvite } from "../utils/introTour";
import { initIntroTourAfterLogin } from "../utils/introTour";
import { getBidCountShweHour } from "../Redux/futures/Bid/action";
import CheckScreen from "./components/CheckScreen";
import _ from "lodash";
import { setReduxDataTypeIntroTour } from "@/Redux/futures/home/actions";
import i18n from "i18next";
import { hasAuthCookie } from '@/utils/auth';
// GA4 — chieu nguoc cua chien dich Thadingyut 2026 (sheet 12, THD-21/22)
import useMissionEntry from '@/analytics/useMissionEntry';
import { useOnlineStatus } from '@/utils/hooks/useOnlineStatus';
import StateView from '@/component/popups/ui-1/StateView';
import { useTranslation } from 'react-i18next';

function LayoutApp({ children }) {
  // Ban enter_service_from_hub khi nguoi dung tu trang chien dich quay ve
  // ShweDeal qua duong dan nhiem vu (URL co ?mission_id=). Dat o day vi
  // LayoutApp boc MOI route — nhiem vu co the tro ve bat ky man nao.
  useMissionEntry();

  const isOnline = useOnlineStatus();
  const [showNoInternet, setShowNoInternet] = useState(false);
  useEffect(() => {
    setShowNoInternet(!isOnline);
  }, [isOnline]);

  // "Connection timed out": axios (config/service.js) bắn CustomEvent này khi
  // request vượt quá axios.defaults.timeout (15s) — khác mất mạng (navigator.onLine
  // vẫn true nhưng server không phản hồi).
  const [showTimeout, setShowTimeout] = useState(false);
  useEffect(() => {
    const handleTimeout = () => setShowTimeout(true);
    window.addEventListener('app:connection-timeout', handleTimeout);
    return () => window.removeEventListener('app:connection-timeout', handleTimeout);
  }, []);

  // "Server sập": axios (config/service.js) bắn CustomEvent này khi backend
  // trả 5xx hoặc không kết nối được (ERR_NETWORK) — tách riêng UI type "2"
  // vì khác nghĩa với connection-timeout (type "4").
  const [showServerDown, setShowServerDown] = useState(false);
  useEffect(() => {
    const handleServerDown = () => setShowServerDown(true);
    window.addEventListener('app:server-down', handleServerDown);
    return () => window.removeEventListener('app:server-down', handleServerDown);
  }, []);
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const selectorAccount = useSelector(curStateAccount);
  const selectorMiniGame = useSelector(curStateMiniGame);
  const [userInfo, setUserInfo] = useState(selectorAccount.userInfo);
  const location = useLocation();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [checkShowBack, setCheckShowBack] = useState(
    getData("login_with_app") || null,
  );
  const [isShowBgWebsite, setIsShowBgWebsite] = useState(false);

  const msisdn2 = document.getElementById("msisdn_myid").value;
  const afterGetUserBid = (data, isLoading) => {
    if (data && !isLoading) {
      setUserInfo(data.data);
      // Server là nguồn chuẩn cho "không hiện lại" popup mời tour
      // (WEB_USER.is_intro_dismissed, ghi qua POST /front/user/dismiss-intro).
      if (+data.data?.is_intro_dismissed === 0) {
        clearNeverShowTourInvite(data.data?.id);
      }
      if (location.pathname === PATH.LOGIN) {
        navigate(PATH.HOME);
      }
    }
  };

  const afterAutoLogin = async (data, isLoading) => {
    if (data && !isLoading) {
      // CẢNH BÁO: cookie này giờ KHÔNG còn được đọc để quyết định hiển thị popup
      // đổi mật khẩu (popup đã vào hàng đợi ở popupRules.js "pu8", tần suất tuần).
      // Nghĩa là user mới đăng ký không còn được miễn trừ như trước.
      // Muốn giữ miễn trừ: thêm !getItemCookie('hidden-popup-change-pw') vào
      // isEligible của pu8 trong utils/popupRegistry.jsx.
      if (data?.data?.isNewUser) {
        setCookieChangePw();
      }
      // Trước đây chỗ này chỉ ghi localStorage KEY_LOCAL_TYPE_USER mà không
      // dispatch typeIntroTour, nên popup mời xem hướng dẫn không bao giờ hiện
      // trên luồng auto-login (reducer đọc localStorage ở initState, chạy trước
      // khi auto-login xong nên luôn ra TYPE_USER.general).
      initIntroTourAfterLogin({
        typeUser: data?.data?.type_user,
        phoneNumber: msisdn2,
        dispatch,
      });
      setCheckShowBack(1);
      dispatch(
        getCurrentUser({ callback: afterGetUserBid, query: { isdn: msisdn2 } }),
      );
      if (selectorAccount.remainTurn.length === 0) dispatch(getTurnRemain({}));
    }
  };
  
  // Server quyết định có chạy tour hay không qua biến is_show_coach_mark
  const userId = selectorAccount.userInfo?.id;
  const isShowCoachMark = selectorAccount.userInfo?.is_show_coach_mark;
  
  useEffect(() => {
    if (!userId || !isShowCoachMark) return;

    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: TYPE_USER.newNoPackage,
        step: 1,
      }),
    );
    dispatch(increaseCoachMark({}));
  }, [userId, isShowCoachMark]);

  useEffect(() => {
    if (!IS_UPDATE_VERSION_3_PROJECT) {
      if (localStorage.getItem("i18nextLng") !== "my") {
        localStorage.setItem("i18nextLng", "my");
        i18n.changeLanguage("my");
      }
    }
  }, []);

  useEffect(() => {
    let timout;
    let countLogin = 0;
    if (sessionStorage.getItem("logout")) {
      return () => { };
    }

    let checkAutoLogin = () => {
      const msisdn = document.getElementById("msisdn_myid").value;
      const tokenEncoded = document.getElementById("token_myid").value;

      if (
        (msisdn && !msisdn.includes("<!--#")) ||
        (tokenEncoded && !tokenEncoded.includes("<!--#"))
      ) {
        if (!getData("login_with_app") || getData("login_with_app") != 1) {
          localStorage.removeItem("login_with_app");
          setData("login_with_app", 1);
        }
      }

      if (
        msisdn &&
        tokenEncoded
        // &&
        // !(cookies.get("isLoggedIn") !== undefined && cookies.get("isLoggedIn"))
      ) {
        const body = {
          isdn: msisdn,
          tokenEncoded,
          from: "dq",
          callback: afterAutoLogin,
        };
        dispatch(loginWithPassword(body));
      } else {
        if (countLogin < 10) {
          timout = setTimeout(() => {
            countLogin++;
            checkAutoLogin();
          }, 500);
        }
      }
    };
    checkAutoLogin();
    return () => {
      clearTimeout(timout);
    };
  }, []);

  useEffect(() => {
    // Config minigame lấy cả khi là guest: popup mời Minigame (pu7) cũng hiện
    // cho guest (spec 2b) và cần is_show để quyết định.
    if (!selectorMiniGame.configMiniGame || _.isEmpty(selectorMiniGame.configMiniGame))
      dispatch(getConfigMiniGame());

    const isLoggedIn = hasAuthCookie() || Boolean(selectorAccount.token) || Boolean(selectorAccount.userInfo);
    if (!isLoggedIn) return;

    if (selectorAccount.userInfo) setUserInfo(selectorAccount.userInfo);
    else dispatch(getCurrentUser({ callback: afterGetUserBid }));

    if (selectorAccount.remainTurn.length === 0) dispatch(getTurnRemain({}));
  }, [selectorAccount.userInfo, selectorAccount.token]);

  useEffect(() => {
    if (selectorAccount.token) {
      dispatch(getCurrentUser({ callback: afterGetUserBid }));
    }
  }, [selectorAccount.token]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsShowBgWebsite(true);
  }, [location.pathname]);

  // Cờ Master toàn cục trong store (suy từ rank login-streak).
  const isMaster = useSelector(curIsMaster);

  useEffect(() => {
    if (selectorAccount.userInfo) {
      dispatch(getBidCountShweHour());
    }
  }, [selectorAccount.userInfo]);

  /* Thu nhỏ TOÀN APP bằng transform:scale khi hiển thị trên DESKTOP để trang vừa
     chiều cao màn hình (đỡ phải cuộn). Mobile giữ nguyên cỡ thật.
       scale = min(1, viewportH / chiềuCaoLayoutCủaCanvasChuẩn)
     Tỉ lệ CHỈ phụ thuộc viewport + canvas design chuẩn (DESIGN_CANVAS), KHÔNG
     phụ thuộc chiều cao nội dung của route đang mở: trước đây lấy
     viewportH / offsetHeight nên màn ngắn ra scale 1 còn màn dài ra 0.7, cùng
     một cỡ chữ lại to nhỏ khác nhau giữa các màn.
     Origin top-center: ghim mép trên + canh giữa ngang. Vẫn đo offsetHeight
     (transform không ảnh hưởng số đo layout) nhưng chỉ để đặt height cho bọc
     ngoài = chiềuCaoĐãScale + overflow hidden, cho tài liệu cuộn đúng phần nhìn
     thấy, không chừa khoảng trống thừa bên dưới.
     minHeight = viewportH/scale (px LAYOUT, bù lại đúng phần transform thu nhỏ):
     các màn ngắn hơn canvas chuẩn chỉ có `min-height: 100svh` của
     .main-layout-website nên sau khi scale cao 100svh*scale -> hụt một dải nền
     dưới đáy. Quy đổi ngược qua scale thì mọi màn phủ tối thiểu đúng chiều cao
     cửa sổ, mà scale vẫn là hằng số dùng chung nên cỡ chữ không đổi giữa các màn.
     (Modal của Radix portal ra body nên nằm NGOÀI vùng scale -> không bị thu nhỏ.) */
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const scaleContentRef = useRef(null);
  const [appScale, setAppScale] = useState({
    scale: 1,
    height: null,
    minHeight: null,
  });
  useLayoutEffect(() => {
    if (isMobile) {
      setAppScale({ scale: 1, height: null, minHeight: null });
      return undefined;
    }
    const measure = () => {
      const el = scaleContentRef.current;
      if (!el) return;
      // Bề rộng cột thật (kẹp theo viewport khi cửa sổ hẹp hơn cột design).
      const columnW = Math.min(DESIGN_CANVAS.COLUMN_WIDTH, window.innerWidth);
      // Chiều cao LAYOUT của canvas chuẩn sau khi UseResponsive scale 880 -> columnW.
      const baseH =
        DESIGN_CANVAS.HEIGHT * (columnW / DESIGN_CANVAS.WIDTH);
      // APP_SCALE_BOOST: nới thêm so với mức khít cửa sổ, đổi lại cuộn một đoạn.
      const scale = Math.min(
        1,
        (window.innerHeight / baseH) * APP_SCALE_BOOST,
      );
      const minHeight = window.innerHeight / scale;
      // chiều cao layout thật (không bị scale), sàn là minHeight
      const naturalH = Math.max(el.offsetHeight, minHeight);
      setAppScale({ scale, height: naturalH * scale, minHeight });
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (scaleContentRef.current) ro.observe(scaleContentRef.current);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [isMobile, location.pathname]);

  // Phát tỉ lệ thu nhỏ ra context để các phần tử PORTAL ra document.body (nằm
  // ngoài cây bị transform:scale bên dưới, vd SocialLinks) vẫn tự áp dụng đúng
  // tỉ lệ này qua useAppScale() thay vì tự động ăn theo transform của tổ tiên.
  const appScaleContextValue = useMemo(
    () => ({ scale: isMobile ? 1 : appScale.scale, isMobile }),
    [isMobile, appScale.scale],
  );

  if (location.pathname.includes("mini-game")) {
    return (
      <>
        <div
          className={`${isShowBgWebsite ? "container-website container-website-mini-game" : ""}`}
        >
          <div className="" style={{ maxWidth: "1170px", margin: "0 auto" }}>
            {/* <CheckScreen /> */}
            <div
              // className={`app-layout flex min-h-screen flex-col overflow-x-clip ${isMaster ? "bg-[#bf1e07]" : "bg-[#ff802b]"}`}
              style={{
                boxShadow:
                  " 0 0 0 2px rgba(255,255,255,.35), 0 18px 45px rgba(0,0,0,.35), 0 35px 80px rgba(0,0,0,.25)",
              }}
            >
              {children}
            </div>
            {/* <OrientationLock /> */}
          </div>
        </div>
      </>
    );
  }

  return (
    <AppScaleProvider value={appScaleContextValue}>
      {/* Trang login dùng ảnh nền riêng (bgsd.webp), các trang còn lại giữ bgsd_new.jpeg. */}
      <div
        className={`${isShowBgWebsite ? "container-website" : ""} ${location.pathname === PATH.LOGIN ? "container-website-login" : ""
          }`}
      >
        <div
          style={
            !isMobile && appScale.height
              ? { height: appScale.height, overflow: "hidden" }
              : undefined
          }
        >
          <div
            ref={scaleContentRef}
            className="main-layout-website"
            style={
              !isMobile
                ? {
                  transform: `scale(${appScale.scale})`,
                  transformOrigin: "top center",
                  minHeight: appScale.minHeight
                    ? `${appScale.minHeight}px`
                    : undefined,
                }
                : undefined
            }
          >
            <CheckScreen />
            <div
              className={`app-layout flex min-h-screen flex-col overflow-x-clip ${isMaster ? "bg-[#bf1e07]" : "bg-[#ff802b]"}`}
            >
              {children}
            </div>
            {/* Popup đổi mật khẩu trước đây render ở đây (ngoài hàng đợi) nên
                có thể chồng lên popup khác. Nay đã vào hàng đợi ưu tiên:
                utils/popupRules.js id "pu8", priority 2, tần suất 1 lần/tuần. */}
            <ModalRender />
            {/* Popup mời bắt đầu tour — luồng người mới, NGOÀI popup manager. */}
            <NewUserTourInvite />
            <StateView
              title={t('no_internet_connection')}
              open={showNoInternet}
              onOpenChange={setShowNoInternet}
              handleClick={() => window.location.reload()}
              type="1"
            />

            <StateView
              title={t('connection_timed_out')}
              open={showTimeout}
              onOpenChange={setShowTimeout}
              handleClick={() => window.location.reload()}
              type="4"
            />

            <StateView
              title={t('temporarily_unavailable')}
              open={showServerDown}
              onOpenChange={setShowServerDown}
              handleClick={() => window.location.reload()}
              type="2"
            />
            {/* <OrientationLock /> */}
          </div>
        </div>
      </div>
    </AppScaleProvider>
  );
}

export default LayoutApp;
